import { render } from "./StatisticInternationalCmp.vue?vue&type=template&id=c2621f3c"
import script from "./StatisticInternationalCmp.vue?vue&type=script&lang=js"
export * from "./StatisticInternationalCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__